import React from 'react';
import { Paintbrush, Info, Phone } from 'lucide-react';

const Hero = ({ page = 'home' }) => {
  const content = {
    home: {
      icon: Paintbrush,
      title: 'Customize',
      subtitle: 'Bring your imagination to life'
    },
    about: {
      icon: Info,
      title: 'Sobre',
      subtitle: 'Learn about us'
    },
    contact: {
      icon: Phone,
      title: 'Contato',
      subtitle: 'Get in touch with our friendly support team'
    }
  };

  const { icon: Icon, title, subtitle } = content[page];

  return (
    <section 
      className={`bg-violet-50 text-white py-12 relative border-t border-b-2 border-purple-200`}
      style={{
        position: 'relative',
        isolation: 'isolate'
      }}
    >
      {/* Pattern overlay */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center">
          <div className="relative inline-block mb-6">
            {/* Background icon positioned on the left side, partially behind the title */}
            <div className="absolute left-0 top-1/2 transform -translate-y-1/2 lg:-translate-x-24 md:-translate-x-20 -translate-x-16 opacity-10 pointer-events-none">
              <Icon className="w-16 h-16 md:w-20 md:h-20 text-purple-900" />
            </div>
            
            <h1 className="text-4xl md:text-6xl font-bold relative z-10">
              <span className="bg-gradient-to-r from-gray-600 to-gray-500 bg-clip-text text-transparent">
              {title}
              </span>
            </h1>
          </div>
          
          <p className="text-xl md:text-2xl text-gray-600">
            {subtitle}
          </p>
        </div>
      </div>
    </section>
  );
};

export default Hero;